import { createSlice } from "@reduxjs/toolkit";

export const AddSlice = createSlice({
    name:"addResponse",
    initialState: {
        addResult:{
            type:"",
            status:"",
            statusText:"",
            response:{}
        }
    },
    reducers:{
        ADD_RESPONSE:(state, action)=>{
            if (action.payload) {
                state.addResult.status = action.payload.status
                state.addResult.type = action.payload.type
                state.addResult.statusText = action.payload.statusText
            }
        },
        ADD_RESPONSE_JSON:(state, action)=>{
            if(action.payload!==null){
                state.addResult.response = action.payload
            }
        },
        CLEAR_RESPONSE:(state, action)=>{
            if(action.payload){
                state.addResult = {
                    type:"",
                    status:"",
                    statusText:"",
                    response:{}          
                }
            }
        }
    }
})
export const {
    ADD_RESPONSE,
    ADD_RESPONSE_JSON,
    CLEAR_RESPONSE
} = AddSlice.actions

export default AddSlice.reducer